import template from './templates/ktVerificationHistory.tmpl.html';

export default function VerificationHistory(
    userService,
    tripUtils,
    l10nService
) {
    'ngInject';

                return {
                    restrict: 'E',
                    template,
                    scope: {
                        tripDetails: '=',
                        reviews: '=',
                        isAutoOpened: '=?',
                        verificationHistoryOpened: '=?',
                    },
                    bindToController: true,
                    controllerAs: 'verificationHistoryCtrl',
                    controller: verificationHistoryCtrl,
                };

                function verificationHistoryCtrl() {
                    const vm = this;

                    activate();

                    function activate() {
                        vm.l10n = l10nService;
                        vm.isAutoOpened = Boolean(vm.isAutoOpened);
                        vm.verificationHistoryOpened = vm.isAutoOpened;
                        vm.regionalSettings = userService.getRegionalSettings();
                        openFirstReview();

                        vm.toggleVerificationHistory = toggleVerificationHistory;
                        vm.isOpenedVerificationHistory = isOpenedVerificationHistory;
                        vm.atLeastOneReviewWasSent = atLeastOneReviewWasSent;
                        vm.getItemStatusText = getItemStatusText;
                        vm.countDays = tripUtils.countDays;
                        vm.getFlightGroupDepartureDate = getFlightGroupDepartureDate;
                        vm.getFlightGroupArrivalDate = getFlightGroupArrivalDate;
                        vm.getFlightGroupDiffDates = getFlightGroupDiffDates;
                    }

                    function openFirstReview() {
                        const firstReview = vm.reviews[0];

                        if (firstReview) {
                            firstReview.isOpened = true;
                        }

                    }

                    function isOpenedVerificationHistory() {
                        return vm.verificationHistoryOpened;
                    }

                    function toggleVerificationHistory() {
                        vm.verificationHistoryOpened = !vm.verificationHistoryOpened;
                    }

                    function atLeastOneReviewWasSent() {
                        return vm.reviews.length;
                    }

                    function getItemStatusText(userReview, tripItemId) {
                        switch (true) {
                            case userReview.isTripItemIdDeclined(tripItemId):
                                return l10nService.localize('Rejected');
                            case userReview.isTripItemIdApproved(tripItemId):
                                return l10nService.localize('Accepted');
                            default:
                                return l10nService.localize('Not indicated');
                        }
                    }

                    function getFlightGroupDepartureDate(flightGroup) {
                        const times = tripUtils.getFlightGroupTime(flightGroup);
                        return times[0];
                    }

                    function getFlightGroupArrivalDate(flightGroup) {
                        const times = tripUtils.getFlightGroupTime(flightGroup);
                        return times[1];
                    }

                    function getFlightGroupDiffDates(flightGroup) {
                        const times = tripUtils.getFlightGroupTime(flightGroup);
                        const arrivalDate = moment(times[0]);
                        const departureDate = moment(times[1]);
                        return Math.floor(departureDate.unix() / 86400) - Math.floor(arrivalDate.unix() / 86400);
                    }
                }
}



// WEBPACK FOOTER //
// ./src/app/modules/trip/directives/ktVerificationHistory.directive.js